export default "__VITE_ASSET__3b4c1ffd__"